import { forwardRef, type KeyboardEvent } from 'react'
import { cn } from '../utils/cn.ts'

/* ── WalletBalance ─────────────────────────────────────────────── */

export interface WalletBalanceProps {
  amount: string
  className?: string
}

export const WalletBalance = forwardRef<HTMLDivElement, WalletBalanceProps>(
  function WalletBalance({ amount, className }, ref) {
    return (
      <div ref={ref} className={cn('wallet-balance', className)}>
        <div className="wallet-balance-icon" aria-hidden="true">$</div>
        <div className="wallet-balance-text">
          <span className="wallet-balance-label">Wallet Balance</span>
          <span className="wallet-balance-amount">{amount}</span>
        </div>
      </div>
    )
  },
)

/* ── WalletToggle ──────────────────────────────────────────────── */

export interface WalletToggleProps {
  checked: boolean
  onChange: (checked: boolean) => void
  label: string
  className?: string
}

export const WalletToggle = forwardRef<HTMLDivElement, WalletToggleProps>(
  function WalletToggle({ checked, onChange, label, className }, ref) {
    function handleClick() {
      onChange(!checked)
    }

    function handleKeyDown(e: KeyboardEvent<HTMLButtonElement>) {
      if (e.key === ' ' || e.key === 'Enter') {
        e.preventDefault()
        onChange(!checked)
      }
    }

    return (
      <div ref={ref} className={cn('wallet-toggle', className)}>
        <span className="wallet-toggle-label">{label}</span>
        <button
          type="button"
          role="switch"
          aria-checked={checked}
          tabIndex={0}
          className={cn(
            'wallet-toggle-switch',
            checked && 'wallet-toggle-switch-checked',
          )}
          onClick={handleClick}
          onKeyDown={handleKeyDown}
        >
          <span className="wallet-toggle-thumb" />
        </button>
      </div>
    )
  },
)
